/**
 * Kontext des Projekt-Popups (PV-052 L5, #108). Eigene Datei, damit `befund-zeile.tsx` den Hook
 * nutzen kann, ohne `project-detail.tsx` zu importieren — der Weg Projektdetail → Hinweisleiste
 * → Befund-Zeile → Popup → Projektdetail wäre sonst ein Import-Kreis.
 */
import { createContext, useContext } from 'react';

export type ProjektPopup = { oeffne: (projectId: string) => void };

export const ProjektPopupKontext = createContext<ProjektPopup | null>(null);

/** `null` außerhalb des Providers — der Link bleibt dann ein normaler Link. */
export function useProjektPopup(): ProjektPopup | null {
  return useContext(ProjektPopupKontext);
}

/**
 * Nur der einfache Linksklick öffnet das Popup (Nutzerentscheid 2026-09-19). Strg/Cmd/Shift/Alt
 * und Mittelklick bleiben beim Link (neuer Tab/Fenster).
 */
export function istEinfacherKlick(e: {
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  defaultPrevented: boolean;
}): boolean {
  return (
    !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
  );
}
